import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, BaseApiService } from '@fc-core/services/base-api.service';
import type { Hardware } from '@fc-core/models/hardware.model';

@Injectable({ providedIn: 'root' })
@ApiService({ baseName: 'hardware' })
export class HardwareApiService extends BaseApiService {
  private readonly http = inject(HttpClient);

  load(id: number): Observable<Hardware> {
    return this.http.get<Hardware>(this.getUrl(id));
  }
}
